Namespace 'CustomerVisualMode'

class CustomerVisualMode.SubtypeWidgetDataTranslator
  constructor: ->
    @translator = new Customer.Filters.SubTypeTranslator()

  name: (dataItem, {locale} = {}) ->
    @translator.getSubtypeTranslation(dataItem.name, {locale})
